export default __webpack_public_path__ + "static/media/five.931dfa8b.svg";